import React from "react";
// import AddMedicalrecord from "./AddMedicalrecord";
// import {Table, Row, Card, CardBody, Col, Button} from 'reactstrap'
import { Link } from "react-router-dom";
import { medicalDocument, medicalSubDocument, documentsType } from '../configData';
import { getMedicalRecords, downloadMedicalRecord, deleteMedicalRecords } from '../../services'
import {
  Table,
  Button,
  Row,
  Col
} from "reactstrap";
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from "react-accessible-accordion";
import { downloadFile } from '../../../utils';
import { showConfirmation, showSuccess } from '../../../utils/alerts';
import ShareSingleRecord from '../ShareSingleRecord';

class ViewMedicalrecord extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      medicalRecords: {},
      modalOpen: false,
      sharedRecordId: null
    }
  }

  async componentDidMount() {
    const res = await getMedicalRecords();

    let medicalRecords = {}

    res.data.records.forEach((record, index) => {
      medicalRecords[record['document']['documentType']] = medicalRecords[record['document']['documentType']] || [];
      medicalRecords[record['document']['documentType']].push(record);
    })

    this.setState(prevState => ({
      medicalRecords: {...medicalRecords}
    }))
  }

  handleDelete = async (documentType, recordId) => {
    const result = await showConfirmation("Yes, delete it!")
    if(result.value == true) {
      await deleteMedicalRecords({data: { recordId }});
      
      const { medicalRecords } =this.state;
      medicalRecords[documentType] = medicalRecords[documentType].filter(record => record._id !== recordId)
  
      this.setState(prevState => ({
        medicalRecords: { ...medicalRecords}
      }))
      await showSuccess("success", "Deleted!", "Your file has been deleted");
    }
  }

  handleDownload = async (recordId) => {
    let data = {
      recordId
    }

    const response = await downloadMedicalRecord(data);
    downloadFile(response.data, 'Medical_Record');
    return;
  }

  handleShare = (recordId) => {
    this.setState(prevState => ({
      sharedRecordId: recordId,
      modalOpen: true
    }))
  }

  toggle = () => {
    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen
    }))
  }

  render() {

    const { modalOpen, sharedRecordId } = this.state;

    return (
      <div>
        <Row>
          <Col xs="12" lg="12" style={{ marginTop: "20px" }}>
            <Accordion className="accordion">
              {medicalDocument.map((document, index) => (
                <AccordionItem className="accordion__item" key={index} onClick={(e) => (console.log("abc"))}>
                  <AccordionItemHeading className="accordion__heading">
                    <AccordionItemButton className="accordion__button">
                      {document['label']}
                      <div className="text-right">
                        <Button
                          className="btn text-right"
                          tag={Link}
                          to={{
                            pathname: "/personalhealthrecord/addgeneralmedicalrecord",
                            state: {
                              type: document
                            }                            
                          }}
                        > <i className="fa fa-plus-circle mr-2 text-right"/> Add New Record
                        </Button>
                      </div>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <Table responsive>
                      <thead className="tableHeader">
                        <tr>
                          <th>S.No</th>
                          <th>Date of Appointment</th>
                          <th>Hospital/Clinic</th>
                          <th>Doctor Name</th>
                          <th>Sub Type of Document</th>
                          <th>Title of Document(s)</th>
                          <th>File Uploaded</th>
                          <th colSpan={2}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.medicalRecords[document['value']] && this.state.medicalRecords[document['value']].map((record, index) => (
                          <tr>
                            <td>{ index + 1 }</td>
                            <td>{ record.document.appointment.slice(0, 10) }</td>
                            <td>{ record.hospitalName }</td>
                            <td>{ record.doctorName }</td>
                            <td>{ medicalSubDocument[record.subDocumentType]['label'] }</td>
                            <td>{ record.document.title}</td>
                            <td>{ `${record.document.files.length} files` }</td>
                            <td>                             
                              <Link to={`/personalhealthrecord/editmedicalrecord/${record._id}`}>
                                <i className="editDiary fa fa-pencil editable-icons" />
                              </Link>
                              <i
                                onClick={() => this.handleDownload(record._id)}
                                className="downloadRecord fa fa-download editable-icons"
                              />
                              <i className="shareRecord fa fa-share editable-icons" 
                                onClick={() => this.handleShare(record._id)}
                              />               
                              <i 
                                className="deleteRecord fa fa-trash editable-icons"
                                onClick={() => this.handleDelete(document['value'], record._id)}
                              />                              
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </AccordionItemPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </Col>
        </Row>
        <ShareSingleRecord isOpen={modalOpen} recordId={sharedRecordId} toggle={this.toggle} model="2"/>
      </div>
    );
  }
}

export default ViewMedicalrecord;



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/GeneralMedicalRecord/ViewMedicalrecord.js